import { defineMessages } from 'react-intl';

export default defineMessages({
    deleteTitle: {
        id: 'twia.managepaymentmethods.Delete Popup Title',
        defaultMessage: 'Before deleting this payment method, please note:'
    },
    deleteBody1_1: {
        id: 'twia.managepaymentmethods.Delete Popup Body 1.1',
        defaultMessage: 'Auto Pay will stop'
    },
    deleteBody1_2: {
        id: 'twia.managepaymentmethods.Delete Popup Body 1.2',
        defaultMessage: 'immediately'
    },
    deleteBody1_3: {
        id: 'twia.managepaymentmethods.Delete Popup Body 1.3',
        defaultMessage: 'for all policies on your account linked to this payment method'
    },
    deleteBody2_1: {
        id: 'twia.managepaymentmethods.Delete Popup Body 2.1',
        defaultMessage: 'To'
    },
    deleteBody2_2: {
        id: 'twia.managepaymentmethods.Delete Popup Body 2.2',
        defaultMessage: 'restart' 
    },
    deleteBody2_3: {
        id: 'twia.managepaymentmethods.Delete Popup Body 2.3',
        defaultMessage: 'Auto Pay, you must re‑enroll each policy'
    },
    deleteBody2_4: {
        id: 'twia.managepaymentmethods.Delete Popup Body 2.4',
        defaultMessage: 'individually'
    },
    deleteBody3_1: {
        id: 'twia.managepaymentmethods.Delete Popup Body 3.1',
        defaultMessage: 'For'
    },
    deleteBody3_2: {
        id: 'twia.managepaymentmethods.Delete Popup Body 3.2',
        defaultMessage: '10-Pay plans,'
    },
    deleteBody3_3: {
        id: 'twia.managepaymentmethods.Delete Popup Body 3.3',
        defaultMessage: 'Auto Pay must be active'
    },
    deleteBody3_4: {
        id: 'twia.managepaymentmethods.Delete Popup Body 3.4',
        defaultMessage: 'before' 
    },
    deleteBody3_5: {
        id: 'twia.managepaymentmethods.Delete Popup Body 3.5',
        defaultMessage: 'the next invoice billed date'
    },
    accept: {
        id: 'twia.managepaymentmethods.Delete Accept',
        defaultMessage: 'Delete'
    }
});
